import EdDescriptions from "./src/EdDescriptions.vue";

/* istanbul ignore next */
EdDescriptions.install = function (Vue) {
  Vue.component(EdDescriptions.name, EdDescriptions)
}

export default EdDescriptions
